/* 西班牙语 */
export default {
  local: {
    reacquire_password: "Vuelva a adquirirlo después ",

    account_login: "Cuenta",
    mobile_number_login: "Móvil",
    authentication_code_login: "Captcha",
    account_name_email: "Cuenta/correo electrónico",
    forgot_password: "¿Ha olvidado su contraseña?",
    please_enter_the_account_number: "Introduzca el número de cuenta",
    please_enter_the_password: "Introduzca la contraseña",
    account_not_registered: "La cuenta no está registrada",
    incorrect_password: "La contraseña es incorrecta",
    not_joined_the_class:
      "No se ha unido a una clase o la clase unida aún no se ha publicado",
    password_lock_time:
      "Si la contraseña es incorrecta, inténtelo de nuevo en 10 minutos",
    password_lock:
      "La cuenta actual está bloqueada, inténtelo de nuevo más tarde",
    phone_number: "Móvil",
    please_enter_your_mobile_number:
      "Por favor, introduzca su número de teléfono móvil",
    mobile_number_format_error: "El formato del número de móvil es incorrecto",
    mobile_number_is_not_registered: "El número de móvil no está registrado",
    verification_code: "Captcha",
    get_verification_code: "Obtenerlo",
    please_enter_the_verification_code: "Introduzca el captcha",
    code_failure_or_error: "El captcha no es válido o es incorrecto",
    code_too_many_times:
      "El número de ocasiones de adquisición de captcha ha superado el límite, inténtelo de nuevo en 24 horas",
    go_back: "Volver",
    reset_your_password: "Restablecer contraseña",
    new_password: "Nueva contraseña",
    save_changes: "Confirmar",
    reset_the_password_by_using_the_email_address: "Restablecer con e-mail",
    please_enter_the_password_address: "Establezca una contraseña",
    your_password_has_been_reset: "La contraseña se ha restablecido",
    password_rule: "6-18 caracteres alfanuméricos y simbólicos",
    emai: "Correo electrónico",
    reset_the_password_by_using_the_mobile_number:
      "Restablecer con el teléfono",
    please_enter_the_email_address: "Introduzca su correo electrónico",
    unregistered_mailbox: "El correo electrónico no está registrado",

    student: "Estudiante",
    teacher: "Profesor/a",
    assistant: "Tutor/a",
    sign_in: "Entrar",
    identity_to_sign_in: "Seleccione la identidad para iniciar sesión",
    change_password: "Cambie contraseña",
    switch_identity: "Cambiar la identidad",
    sign_out: "Cerrar sesión",
    class_on_phones: "Clase con móvil",
    mobile_terminal_by_scanning:
      "Puede acceder después de escanear el código\n" + "QR o abrir el enlace",
    copy_link: "Copiar el enlace",
    shut_off: "Apagar",
    account: "Cuenta",
    old_password: "Contraseña antigua",
    re_enter_password: "Introducir de nuevo",
    please_enter_the_old_password: "Introduzca su contraseña anterior",
    please_enter_the_new_password: "Introduzca una nueva contraseña",
    please_re_enter_the_new_password: "Introduzca de nuevo la nueva contraseña",
    password_modified_successfully: "La contraseña se ha modificado",
    old_password_error: "La contraseña anterior es incorrecta",

    user_name: "Nombre de usuario",
    password: "Contraseña",
    login: "Iniciar sesión",
    the_user_name_or_password_is_incorrect: "Usuario o contraseña invalido",
    note: "Nota",
    log_out: "Cerrar sesión",
    certificate_application: "Solicitud de certificado",
    more: "Más",
    close: "Cerrar",
    learn_courses: "Cursos de aprendizaje",
    class_schedule: "Calendario",
    data_download: "Descargar",
    selective_courses: "Cursos selectivos",
    receive_notices: "Recibir avisos",
    to_do_list: "Lista de quehaceres",
    important_notices: "Avisos",
    write_summary: "Escribir resumen",
    project_comment: "Comentario del proyecto",
    feedback: "Feedback",
    my_summary: "Mi resumen",
    evaluate_service_quality: "Evaluar la calidad del servicio",
    completed: "Terminado",
    unavailable: "Indisponible",
    uncompleted: "Incompleto",
    coming_soon: "Próximamente",
    application_successful: "¡Solicitud exitosa!",
    the_certificate_will_be_sent_to_your_mail:
      "El certificado se enviará a su correo el día de la finalización de sus cursos. Si tiene alguna pregunta, comuníquese con su asesor de clase.",
    ok: "OK",
    please_complete_your_to_do_list:
      "Complete su lista de quehaceres antes de solicitar el certificado.",
    to_complete: "OK",
    would_you_like_to_check_your_reports:
      "¿Le gustaría verificar sus informes antes de solicitar el certificado?",
    no_modification_upon_submission: "Una vez enviados, no se pueden revisar.",
    go_and_check: "comprobar",
    submit: "Entregar",
    application_submitted: "Solicitud presentada",
    my_class: "Mi clase",
    course_calendar: "Calendario de cursos",
    back_to_today: "Volver a hoy",
    today: "Hoy día",
    course_replay: "Repetición del curso",
    no_courses: "No hay cursos",
    monday: "lunes",
    tuesday: "martes",
    wednesday: "miércoles",
    thursday: "jueves",
    friday: "viernes",
    saturday: "sábado",
    sunday: "domingo",
    instructor: "Profesor",
    comment: "Comentario",
    replay: "Repetición",
    join: "Unirse",
    class_begins_at: "Hora y fecha",
    lasting_for: "Duración",
    all: "Todo",
    video: "Vídeos",
    image: "Imagen",
    no_data: "Indisponible",
    china_today_serial_courses: "China hoy",
    language: "Idioma",
    features: "Temas",
    finance: "Finanzas de China",
    trade: "Comercio de China",
    commerce: "Negocios de China",
    planning: "Planificación urbana de China",
    infrastructure: "Infraestructura de China",
    development_cooperation:
      "Cooperación Internacional para el Desarrollo de China",
    important_notices_title: "Avisos",
    all_notes: "Todo",
    course: "Curso",
    event: "Evento",
    class: "Clase",
    task: "Tarea",
    no_notes: "Indisponible",
    content: "Contenido",
    turn_to_page: "Pasar a la página XXX",
    please_complete_the_report: "Complete el informe XXX.",
    please_complete_the_course_comment: "Complete el comentario sobre XXX.",
    fill_in: "Llenar",
    no_matter: "Indisponible",
    list: "Lista",
    original: "Original",
    speed: "Velocidad",
    scored: "XXX puntos",
    fill_in_at_least_XXX_characters: "Ingrese al menos XXX caracteres.",
    words_already_entered: "XXX palabras ingresadas.",
    submission_successful: "Envío exitoso",
    up_to_10000_words: "¡10,000 palabras como máximo!",
    up_to_20000_words: "¡20.000 palabras como máximo!",
    up_to_50000_words: "¡50.000 palabras como máximo!",
    course_comment: "Comentario del curso",
    to_submit: "Entregar",
    to_close: "Cerrar",
    instructions: "Instrucción",
    evaluation_type: "Tipo del calificación",
    very_good: "Muy bien",
    good: "Bien",
    bad: "Mal",
    total_points: "Notas Totales",
    trainers_level: "El nivel de instructor",
    teaching_material_quality: "La calidad de libro de texto",
    translation_level: "El nivel de traducción",
    interactive_communication_situation: "La situación de interacción",
    multimedia_teaching_quality: "La calidad de la enseñanza de multimedia",
    course_degree_of_difficulty: "El grado de dificultad del clase",
    correlation_between_course_and_the_program_theme:
      "La relevancia del contenido de curso con el tema del proyecto",
    comment_table_score_hint:
      "Notas: Muy bien nota dos puntos, bien nota uno punto, mal nota cero punto, la nota completa de cada curso son catorce puntos.",
    participants_feedback_form: "Formulario de Feedback de Seminaristas",
    participants_feedback_form_state:
      "Sinceras felicitaciones a usted por cumplir este seminario. Haga el favor de rellenar el formulario de feedback de seminaristas.",
    participants_feedback_form_instructions:
      "El formulario de Feedback de participantes sirve para presentar sus opiniones y sugerencias sobre el proyecto de formación en general.<br/>" +
      "Además de conocer sus opiniones sobre el seminario, también nos gustaría conocer sus necesidades y sugerencias para futuros programas:<br/>" +
      "1.¿Qué temas le gustaría que ofreciéramos en los cursos?<br/>" +
      "2.¿Qué ciudades chinas le gustaría visitar?<br/>" +
      "3.¿Qué tipo de empresas chinas le gustaría visitar?<br/>" +
      "4.¿Tiene planes de cooperación comercial, educativa o de otro tipo en China o Shanghai?<br/>" +
      "5.¿Tiene necesidades específicas de cooperación empresarial?",
    final_report: "Reporte Final",
    final_report_state:
      "Sinceras felicitaciones a usted por cumplir este seminario. Haga el favor de rellenar el reporte final.",
    final_report_instructions:
      "El informe debe incluir los cuatro aspectos siguientes:<br/>" +
      "1. Introducción de los datos básicos de los participantes y sus motivos de participación.<br/>" +
      "2. El resumen y la comparación entre sus paises y China sobre los temas del seminario. Los aspectos referidos son ilimitados.<br/>" +
      "3. Compartan los aspectos mejores y los beneficios del seminario.<br/>" +
      "4. Expectativas y sugerencias después del seminario.<br/>" +
      "(Solo por referencia)",
    trainee_evaluation_form_of_foreign_assistance_training_program:
      "El formulario de evaluación de los alumnos del proyecto de formación de la asistencia exterior",
    trainee_evaluation_form_of_foreign_assistance_training_program_state:
      "Muchas gracias por tu participación en nuestro seminario/formación. Para mejorar nuestro trabajo constantemente, haga un favor de hacer una evaluación objetiva del nuestro seminario / formación. Y expresen sus opiniones sobre las cuestiones siguientes. Gracias por su cooperación.",
    trainee_evaluation_form_of_foreign_assistance_training_program_instructions:
      "El formulario de evaluación es una evaluación integral del seminario, y se espera que la evaluación refleje fielmente las condiciones reales de los proyectos realizados por nuestra base. Sus opiniones y evaluaciones son de gran importancia para el reconocimiento y  la mejora del trabajo de la base. El puntaje máximo de cada ítem es <span>5</span>, y el puntaje total es <span>100</span>.",
    foreign_aid_training_service_quality_survey:
      "Encuesta de la Escuela de Negocios de Shanghai sobre la Calidad de los Programas de Capacitación de Funcionarios para Asistencia a Extranjeros 		",
    foreign_aid_training_service_quality_survey_state:
      "Muchas gracias por haber asistido a este programa de capacitación.  Para ayudarnos a mejorar la calidad general de nuestros programas de capacitación de funcionarios para asistencia a extranjeros, por favor complete esta encuesta de evaluación de los servicios con sus comentarios y sugerencias, los cuales serán de gran ayuda para identificar las áreas de mejora. ",
    foreign_aid_training_service_quality_survey_instructions:
      "Por favor, califique cada servicio colocando una marca de verificación (√) en la casilla correspondiente a la puntuación elegida.  La puntuación indica el nivel de su satisfacción con el servicio; 5 = muy satisfecho, 4 = satisfecho, 3 = neutral, 2 = insatisfecho y 1 = muy insatisfecho.  Si tiene algún comentario adicional, por favor escríbalo en la sección Comentarios. ",
    points: "Calificación",
    training: "Formación",
    course_arrangement: "La disposición del contenido del curso",
    suitability_of_course_quantity: "La idoneidad de la cantidad del clase",
    quality_of_teaching_materials_or_handouts:
      "La calidad de material didáctico o material de enseñanza",
    correlation_between_study_tours_and_the_program_theme:
      "El contacto entre vistación y proyecto topic",
    arrangement_for_study_tours_or_internships:
      "La disposición de vistación o prácticas",
    classrooms_and_teaching_equipments: "La aula y enseñanza equipo",
    management: "Administración",
    accommodation:
      "La condición del alojamiento (selecciona 0 si no es dormitorio  individual)",
    airport_transfer_and_catering_services_arrangement:
      "La disposición de alimento y avión ",
    opening_and_closing_ceremonies_arrangement:
      "La disposición de la ceremonia del comienzo de clase y la graduación",
    cultural_experience_and_extracurricular_activities_arrangement:
      "La experiencia culturaly la disposición de actividad extracurricular",
    attitude_of_the_Chinese_staff: "La actitud de trabajador chino",
    organizational_skills_of_the_Chinese_staff:
      "La capacidad de organización de trabajador chino",
    english_communication_skills_of_the_Chinese_staff:
      "La capacidad de comunicación de trabajador chino en lengua extranjera ",
    synthesis: "Síntesis",
    program_duration: "Duración del proyecto",
    help_of_the_program_on_your_future_work:
      "La ayuda del proyecto a usted en su trabajo futuro",
    role_of_the_program_in_promoting_cooperation_between_China_and_your_country_in_the_relevant_fields:
      "La función de la promoción del proyecto en campo relacionado por tu país y Chino",
    your_overall_evaluation_of_the_program:
      "Su valoración general por el proyecto",
    your_suggestion_and_comment: "Sus sugerencias y recados",
    your_impression_of_China: "Sus impresiónes de China",
    report: "Reporte",
    error_request: "Solicitud fallida.",
    download_live_streaming_tool:
      "Descarga una herramienta de transmisión en vivo",
    windows_7_and_above: "Windows 7 o una versión superior",
    no_replay: "Indisponible",
    look_over: "Vista",
    mon: "lun",
    tue: "mar",
    wed: "mié",
    thu: "jue",
    fri: "vie",
    sat: "sáb",
    sun: "dom",
    please_enter_a_user_name: "Por favor ingrese el nombre de usuario.",
    your_login_has_timed_out_please_click_the_button_to_log_in_again:
      "Se ha agotado el tiempo de inicio de sesión. Haga clic en el botón para iniciar sesión nuevamente.",
    please_complete_all_comments_before_submission:
      "Por favor complete todos los comentarios antes de enviarlos.",
    please_fill_in: "Por favor escriba.",
    it_cannot_be_empty: "No puede estar vacío.",
    comment_successful: "Comentario exitoso",
    if_there_is_no_prompt_on_the_browser_please_try_again:
      "Si no aparece ningún mensaje en el navegador, inténtelo de nuevo.",
    click_here_to_try_again: "Haga clic aquí para volver a intentarlo.",
    if_you_have_not_installed_the_live_streaming_tool:
      "Si no ha instalado la herramienta de transmisión en vivo, descárguela y vuelva a intentarlo.",
    class_information: "Información de la clase",
    reload: "Recargar",
    you_do_not_have_permission_to_access_the_current_page:
      "Usted no tiene acceso a la página actual",
    return_to_home_page: "Inicio",
    total_points_project_comment: "Notas Totales",
    record_course_over_tip_msg:
      "Ya terminado el curso. Favor de ir al aula interactiva enseguida",
    page_live_entry_tips:
      "Si no puede entrar en el extremo cliente de Classin, por favor visite su página web para estudiar.<br>(no se puede comunicar con profesores en la página web)",
    page_live_entry_txt: "Clase por internet en vivo",
    select_class: "Elegir la clase",
    start: "Empezar a estudiar",
    download: "Descargar",
    class_on_phones: "Clase con móvil",
    class_on_phones_tip:
      "Puede acceder después de escanear el código QR o abrir el enlace",
    copy_successfully: "Copiar el éxito"
  }
};



// WEBPACK FOOTER //
// ./src/lang/es/index.js